export enum ResourceIdType {
  PersonverninnstillingdefinisjonsId = '1',
  Blankettnummer = '2',
  SkjemaId = '3',
  PersonverninnstillingPartkode = '4',
  VerktoyId = '5',
}

export enum ResourceIdParamName {
  Name = 'name',
  Id = 'Id',
}
